export { default } from './ComparisonSelect';
